import api from '@/services/api'
import version from '@/services/version'
import Vue from 'vue';

const SYNC_RUNNING = 2;
const SYNC_FINISH = 1;
const SYNC_WAITING = 0;

let defaultInter = {
	recapitulatif: {
		signataire: '',
		signataire_absent: false,
		signataire_note: '',
		evaluation: '',
		signatureclient: '',
		salarieids: [],
		start_at: '',
		end_at: '',
	},
	interimaire: {
		presence_interimaire: false,
		nom_interimaire: '',
		nombre_heures_interimaire: '',
		conducteur_trajet_aller: '',
		conducteur_trajet_retour: '',
	},
	parcs: {},
	imperatifs: {},
	imperatifsfinlavage: {},
	uid: null,
	sync: null,
}

const store = {
	namespaced: true,
	state: {
		interventions: {}
	}, 
	mutations: {
		setintervention(state, {uid, data}) {
			console.log('setintervention', uid, data);
			if (!state.interventions[uid]) {
				Vue.set(state.interventions, uid, JSON.parse(JSON.stringify({...defaultInter, ...{'uid':uid}, ...data})));
			} else {
				state.interventions[uid] = data
			}
		},
		SET_IMPERATIF(state, {uid, data, value}) {
			if (!state.interventions[uid]) {
				Vue.set(state.interventions, uid, JSON.parse(JSON.stringify({...defaultInter, ...{'uid':uid}})));
			}
			state.interventions[uid].imperatifs[data] = value;
		},
		SET_IMPERATIFFINLAVAGE(state, {uid, data, value}) {
			if (!state.interventions[uid]) {
				Vue.set(state.interventions, uid, JSON.parse(JSON.stringify({...defaultInter, ...{'uid':uid}})));
			}
			state.interventions[uid].imperatifsfinlavage[data] = value;
		},
		ADD_VEHICLE(state, {uid, vehicleid}) {
			if (!state.interventions[uid]) {
				Vue.set(state.interventions, uid, JSON.parse(JSON.stringify({...defaultInter, ...{'uid':uid}})));
			}
			if (!state.interventions[uid].parcs[vehicleid]){
				state.interventions[uid].parcs[vehicleid] = {
					motif: '', // justificatif de non lavage
					motif_autre: '', // justificatif de non lavage
					cle: '',
					typelavage: [],
					start_at: Date.now(),
					end_at: '',
					version: version.version,
				}
			}
		},
		REMOVE_VEHICLE(state, {uid, vehicleid}) {
			if (!state.interventions[uid]) {
				Vue.set(state.interventions, uid, JSON.parse(JSON.stringify({...defaultInter, ...{'uid':uid}})));

			}
			let inter = state.interventions[uid];
			delete inter.parcs[vehicleid];
			state.interventions[uid] = inter;
		},
		
		SET_VEHICLE(state, {uid, vehicleid, data}) {
			if (!state.interventions[uid]) {
				Vue.set(state.interventions, uid, JSON.parse(JSON.stringify({...defaultInter, ...{'uid':uid}})));
			}
			if (!state.interventions[uid].parcs[vehicleid]){
				state.interventions[uid].parcs[vehicleid] = {
					motif: '', // justificatif de non lavage
					motif_autre: '', // justificatif de non lavage
					cle: '',
					typelavage: [],
					start_at: Date.now(),
					end_at: '',
					version: version.version,
				}
			}
			let vehicle = state.interventions[uid].parcs[vehicleid];

			vehicle.motif = data.motif;
			vehicle.motif_autre = data.motif_autre;
			vehicle.cle = data.cle;
			vehicle.typelavage = data.typelavage;
			vehicle.end_at = Date.now();
			vehicle.version = version.version;
			state.interventions[uid].parcs[vehicleid] = vehicle;
		},
		SET_RECAPITULATIF(state, {uid, data}) {
			if (!state.interventions[uid]) {
				Vue.set(state.interventions, uid, JSON.parse(JSON.stringify({...defaultInter, ...{'uid':uid}})));
			}

			state.interventions[uid].recapitulatif.signataire = data.signataire;
			state.interventions[uid].recapitulatif.signataire_absent = data.signataire_absent;
			state.interventions[uid].recapitulatif.signataire_note = data.signataire_note;
			state.interventions[uid].recapitulatif.evaluation = data.evaluation;
			state.interventions[uid].recapitulatif.signatureclient = data.signatureclient;
			state.interventions[uid].recapitulatif.salarieids = data.salarieids;
			state.interventions[uid].recapitulatif.end_at = Date.now();
		},
		SET_INTERIMAIRE(state, {uid, data}) {
			if (!state.interventions[uid]) {
				Vue.set(state.interventions, uid, JSON.parse(JSON.stringify({...defaultInter, ...{'uid':uid}})));
			}

			state.interventions[uid].interimaire.presence_interimaire = data.presence_interimaire;
			state.interventions[uid].interimaire.nom_interimaire = data.nom_interimaire;
			state.interventions[uid].interimaire.nombre_heures_interimaire = data.nombre_heures_interimaire;
			state.interventions[uid].interimaire.debut_heures_interimaire = data.debut_heures_interimaire;
			state.interventions[uid].interimaire.fin_heures_interimaire = data.fin_heures_interimaire;
			state.interventions[uid].interimaire.conducteur_trajet_aller = data.conducteur_trajet_aller;
			state.interventions[uid].interimaire.conducteur_trajet_retour = data.conducteur_trajet_retour;
		},
		reset(state) {
			state.interventions = {};
		},
		CHANGE_SYNC(state, {uid, sync}) {
			if (state.interventions[uid]){
				state.interventions[uid].sync = sync;
			}
		},
		remove(state, uid){
			let inter = {...state.interventions};
			delete inter[uid];
			state.interventions = inter;
		}
	},
	
	actions: {
		setIntervention: ({commit, state}, {uid, data}) => {
			commit('setintervention', {uid, data});
		},
		checkImperatif: ({commit, state}, {uid, data}) => {
			let value = 1
			commit('SET_IMPERATIF', {uid, data, value});
		},
		uncheckImperatif: ({commit, state}, {uid, data}) => {
			let value = 0
			commit('SET_IMPERATIF', {uid, data, value});
		},
		checkImperatifFinLavage: ({commit, state}, {uid, data}) => {
			let value = 1
			commit('SET_IMPERATIFFINLAVAGE', {uid, data, value});
		},
		uncheckImperatifFinLavage: ({commit, state}, {uid, data}) => {
			let value = 0
			commit('SET_IMPERATIFFINLAVAGE', {uid, data, value});
		},

		createVehicle: async ({commit, state}, {uid, data}) => {
			await api.post({
				url: 'intervention/AFCO/parcs/' + uid + '/create',
				params: {
					parc: data
				}
			})
		},
		addVehicle: ({commit, state}, {uid, vehicleid}) => {
			commit('ADD_VEHICLE', {uid,vehicleid});
		},
		saveVehicle: ({commit, state}, {uid, vehicleid, data}) => {
			commit('SET_VEHICLE', {uid,vehicleid, data});
		},
		removeVehicle: ({commit, state}, {uid, vehicleid}) => {
			commit('REMOVE_VEHICLE', {uid,vehicleid});
		},
		saveRecapitulatif: ({commit, state}, {uid, data}) => {
			commit('SET_RECAPITULATIF', {uid, data});
		},
		saveInterimaire: ({commit, state}, {uid, data}) => {
			commit('SET_INTERIMAIRE', {uid, data});
		},
		finishIntervention: async ({commit, state, dispatch}, {uid}) => {
			try {
				commit('CHANGE_SYNC', {uid:uid, sync: SYNC_RUNNING});
				let call = await api.post({
					url: 'intervention/AFCO/missions/' + uid + '/save',
					params: state.interventions[uid]
				})
				commit('CHANGE_SYNC', {uid:uid, sync: SYNC_FINISH});
				dispatch('pictures/sync', {}, {root:true});
			} catch (err) {
				console.log('finishIntervention', err);
				commit('CHANGE_SYNC', {uid:uid, sync: SYNC_WAITING});
			}
		},
		pushAll: ({commit, state, getters, dispatch}) => {
			getters.tosyncs.forEach((item) => {
				dispatch('finishIntervention', {uid: item.uid});
			})
		},
		reset: ({commit, state}) => {
			commit('reset');
		},
		
		async delete(context, uid) {
			console.log('delete inter', uid);
			context.commit('remove', uid);
		},
		
		async removeSynced(context, evtids){
			console.log('removeSynced interventions');
			let inter = context.state.interventions;
			if (Object.keys(inter).length){
				_.forEach(inter, (i,uid) => {
					if (i.sync == SYNC_FINISH && evtids.indexOf(uid) === -1) {
						context.commit('remove', uid);
					}
				})
			}
		},
	},
	getters: {
		getAll: (state) => {
			return state.interventions;
		},
		getIntervention: (state) => (uid) => {
			return state.interventions[uid] ? state.interventions[uid] : JSON.parse(JSON.stringify({...defaultInter, ...{'uid':uid}}));
		},
		getSyncStatus: (state) => (uid) => {
			if (!state.interventions[uid]) {
				return null;
			}
			return state.interventions[uid].sync
		},
		tosyncs: (state) => {
			return Object.values(state.interventions).filter((item) => {
				return item.sync == SYNC_WAITING;
			})
		}
		
	},
}

export default store